var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.UWSSRESOURCES.value
    }
  }, [_c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('table', {
    staticClass: "board-list"
  }, [_c('thead', {
    staticClass: "d-none d-lg-table-header"
  }, [_c('tr', [_c('th', {
    staticClass: "board-list__txt",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("NO.")]), _c('th', {
    staticClass: "board-list__tit",
    staticStyle: {
      "width": "52.5%"
    }
  }, [_vm._v("Subject")]), _c('th', {
    staticClass: "board-list__txt",
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("Writer")]), _c('th', {
    staticClass: "board-list__txt",
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("Date Created")]), _c('th', {
    staticClass: "board-list__txt",
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("Hit")])])]), _c('tbody', _vm._l(_vm.librarys, function (library, index) {
    return _c('tr', {
      key: library._id
    }, [_c('td', {
      staticClass: "board-list__txt board-list__txt--first",
      attrs: {
        "align": "center"
      }
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _c('td', {
      staticClass: "board-list__tit",
      attrs: {
        "align": "center"
      }
    }, [_c('div', {
      staticClass: "ellip"
    }, [_c('router-link', {
      attrs: {
        "to": "/resoures/customer/".concat(library._id)
      }
    }, [_vm._v(_vm._s(library.subject))])], 1)]), _c('td', {
      staticClass: "board-list__txt",
      attrs: {
        "align": "center"
      }
    }, [_vm._v(" " + _vm._s(library.writer.name) + " ")]), _c('td', {
      staticClass: "board-list__txt",
      attrs: {
        "align": "center"
      }
    }, [_vm._v(" " + _vm._s(library.createdAt.toDate()) + " ")]), _c('td', {
      staticClass: "board-list__txt",
      attrs: {
        "align": "center"
      }
    }, [_vm._v(" " + _vm._s(library.viewCount) + " ")])]);
  }), 0)]), _c('div', {
    staticClass: "v-pagination-wrap"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }